export default function (Mousetrap) {
    let _globalCallbacks = {}
    let _originalStopCallback = Mousetrap.prototype.stopCallback

    Mousetrap.prototype.stopCallback = function(e, element, combo, sequence) {
        let self = this

        if (self.paused) {
            return true
        }

        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) {
            return false
        }

        return _originalStopCallback.call(self, e, element, combo)
    };

    Mousetrap.prototype.bindGlobal = function(keys, callback, action) {
        let self = this
        self.bind(keys, callback, action)

        if (keys instanceof Array) {
            for (let i = 0; i < keys.length; i++) {
                _globalCallbacks[keys[i]] = true
            }
            return
        }

        _globalCallbacks[keys] = true
    }

    Mousetrap.init()

    return Mousetrap
}